var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-center",staticStyle:{"width":"100%"}},[(_vm.loading)?[_c('v-skeleton-loader',{attrs:{"type":"image"}})]:_vm._e(),_c('canvas',{ref:"canvas",staticStyle:{"width":"100%","height":"100%"},style:(_vm.style)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }